/* Punki storefront: native Shopify forms and checkout, with editable media. */
(() => {
  'use strict';
  let cleanup = () => {};
  const state = { finish: 'white', view: 'kit', detail: null };
  function parseLaunchDate(value, timeZone) {
    if (/(Z|[+-]\d{2}:?\d{2})$/i.test(value)) return Date.parse(value);
    const parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value || '');
    if (!parts) return NaN;
    const [, y, mo, d, h, mi, s = '0'] = parts;
    const target = Date.UTC(+y, +mo - 1, +d, +h, +mi, +s);
    try {
      const formatter = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      let instant = target;
      for (let n = 0; n < 4; n++) {
        const p = Object.fromEntries(formatter.formatToParts(instant).map(x => [x.type, x.value]));
        const local = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
        if (local === target) return instant;
        instant += target - local;
      }
    } catch { /* Invalid timezone is surfaced by the countdown status. */ }
    return NaN;
  }
  function initialize() {
    cleanup();
    const controller = new AbortController();
    const { signal } = controller;
    const $ = selector => document.querySelector(selector);
    const $$ = selector => Array.from(document.querySelectorAll(selector));
    const on = (element, type, callback, options = {}) => element?.addEventListener(type, callback, { ...options, signal });
    const read = selector => {
      const node = $(selector);
      if (!node) return {};
      try { return JSON.parse(node.textContent); } catch (error) { console.error('Punki section data is invalid', selector, error); return {}; }
    };
    const catalog = read('[data-punki-catalog]');
    const gallery = read('[data-punki-gallery]');
    const intro = read('[data-punki-intro-media]');
    const details = read('[data-punki-details]');
    const currency = catalog.currency;
    const formatMoney = cents => {
      try { return new Intl.NumberFormat(catalog.locale || document.documentElement.lang, { style: 'currency', currency }).format(cents / 100); }
      catch { return ''; }
    };
    function image(element, data) {
      if (!element || !data?.src) return;
      element.classList.remove('is-changing');
      // Set src and srcset together; the previous responsive source cannot win a finish change.
      element.removeAttribute('srcset');
      element.src = data.src;
      const source = data.src.startsWith('//') ? `https:${data.src}` : data.src;
      try {
        const url = new URL(source, location.origin);
        const small = new URL(url); small.searchParams.set('width', '720');
        const large = new URL(url); large.searchParams.set('width', '1600');
        element.srcset = `${small.href} 720w, ${large.href} 1600w`;
      } catch { /* The configured source still works without responsive derivatives. */ }
      element.alt = data.alt || '';
    }
    function showPhoto(view) {
      state.view = ['kit', 'campaign', 'modules'].includes(view) ? view : 'kit';
      const photo = state.view === 'modules' ? gallery.modules : gallery[state.finish]?.[state.view];
      image($('[data-product-image]'), photo);
      $$('[data-view]').forEach((button, index) => {
        const selected = button.dataset.view === state.view;
        button.classList.toggle('selected', selected); button.setAttribute('aria-pressed', String(selected));
        if (selected && $('[data-gallery-label]')) $('[data-gallery-label]').textContent = `${String(index + 1).padStart(2, '0')} — ${button.querySelector('span')?.textContent || ''}`;
      });
    }
    function renderDetail(id) {
      state.detail = details[id] ? id : Object.keys(details)[0];
      const data = details[state.detail];
      if (!data) return;
      const finishData = data[state.finish];
      image($('[data-detail-image]'), finishData?.image);
      const fields = { '[data-detail-eyebrow]': data.eyebrow, '[data-detail-title]': data.title, '[data-detail-copy]': finishData?.copy };
      Object.entries(fields).forEach(([selector, value]) => { if ($(selector)) $(selector).textContent = value || ''; });
      $$('[data-detail]').forEach(button => {
        const selected = button.dataset.detail === state.detail;
        button.classList.toggle('selected', selected); button.setAttribute('aria-pressed', String(selected));
      });
      const caption = $('[data-detail-caption]');
      if (caption) caption.textContent = `${catalog[state.finish]?.name || ''} / ${caption.dataset.caption || ''}`;
    }
    function updateTags() {
      const input = $('[data-signup-tags]');
      if (!input) return;
      const preference = $('[data-signup-preference]')?.value === 'pref-amazon' ? 'pref-amazon' : 'pref-store';
      const finishTag = ($('[data-signup-finish]')?.value || state.finish) === 'black' ? 'finish-matte-black' : 'finish-white';
      input.value = [...input.dataset.baseTags.split(',').map(x => x.trim()).filter(Boolean), preference, finishTag].join(',');
    }
    function updateQuantity() {
      const input = $('[data-quantity-input]');
      if (!input) return;
      const quantity = Math.min(99, Math.max(1, Number.parseInt(input.value, 10) || 1));
      input.value = String(quantity);
      $$('[data-quantity]').forEach(button => { button.disabled = +button.dataset.quantity < 0 ? quantity <= 1 : quantity >= 99; });
      const price = $('[data-add-price]'); if (price) price.textContent = formatMoney((catalog[state.finish]?.price || 0) * quantity);
    }
    function selectFinish(finish) {
      if (!['white', 'black'].includes(finish)) return;
      state.finish = finish;
      const variant = catalog[finish];
      document.documentElement.dataset.finish = finish;
      $$('[data-select]').forEach(button => { const selected = button.dataset.select === finish; button.classList.toggle('selected', selected); button.setAttribute('aria-pressed', String(selected)); });
      $$('[data-finish-name]').forEach(node => { node.textContent = variant?.name || ''; });
      image($('[data-hero-image]'), intro[finish]);
      const heroCaption = $('[data-hero-caption]');
      if (heroCaption) heroCaption.textContent = `${variant?.name || ''} / ${heroCaption.dataset.caption || ''}`;
      $$('[data-view]').forEach(button => image(button.querySelector('img'), button.dataset.view === 'modules' ? gallery.modules : gallery[finish]?.[button.dataset.view]));
      $$('[data-unit-price]').forEach(node => { node.textContent = variant?.formattedPrice || ''; });
      $$('[data-variant-input]').forEach(input => { input.value = variant?.id || ''; });
      const add = $('[data-add]'); if (add) add.disabled = !variant?.available;
      const addLabel = $('[data-add-label]'); if (addLabel) addLabel.textContent = variant?.available ? catalog.addLabel : catalog.soldOutLabel;
      const select = $('[data-signup-finish]'); if (select) select.value = finish;
      showPhoto('kit'); renderDetail(state.detail); updateQuantity(); updateTags();
    }
    $$('[data-select]').forEach(button => on(button, 'click', () => selectFinish(button.dataset.select)));
    $$('[data-view]').forEach(button => on(button, 'click', () => showPhoto(button.dataset.view)));
    $$('[data-detail]').forEach(button => on(button, 'click', () => renderDetail(button.dataset.detail)));
    $$('[data-quantity]').forEach(button => on(button, 'click', () => { const input = $('[data-quantity-input]'); if (input) { input.value = String((+input.value || 1) + +button.dataset.quantity); updateQuantity(); } }));
    on($('[data-quantity-input]'), 'change', updateQuantity);
    on($('[data-signup-preference]'), 'change', updateTags);
    on($('[data-signup-finish]'), 'change', event => selectFinish(event.target.value));
    on($('.punki-customer-form'), 'submit', updateTags, { capture: true });
    on($('[data-choose-black]'), 'click', () => { selectFinish('black'); $('#shop')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
    const menu = $('[data-menu]');
    function closeMenu() { menu?.setAttribute('aria-expanded', 'false'); if ($('#mobile-nav')) $('#mobile-nav').hidden = true; }
    on(menu, 'click', () => { const expanded = menu.getAttribute('aria-expanded') === 'true'; menu.setAttribute('aria-expanded', String(!expanded)); if ($('#mobile-nav')) $('#mobile-nav').hidden = expanded; });
    $$('#mobile-nav a').forEach(link => on(link, 'click', closeMenu));
    on(document, 'keydown', event => { if (event.key === 'Escape') { closeMenu(); menu?.focus(); } });
    const clock = $('[data-launch-countdown]'); let clockTimer;
    function updateClock() {
      if (!clock) return;
      const launch = parseLaunchDate(clock.dataset.launchDate, clock.dataset.launchTimezone);
      const valid = Number.isFinite(launch); clock.hidden = !valid;
      const invalid = $('[data-countdown-invalid]'); if (invalid) invalid.hidden = valid;
      if (!valid) return;
      const remaining = Math.max(0, Math.floor((launch - Date.now()) / 1000));
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      Object.entries(values).forEach(([unit, value]) => {
        const pair = clock.querySelector(`[data-clock-unit="${unit}"]`); if (!pair) return;
        const digits = String(value).padStart(2, '0');
        while (pair.children.length < digits.length) pair.append(pair.lastElementChild.cloneNode(true));
        while (pair.children.length > digits.length) pair.lastElementChild.remove();
        [...pair.children].forEach((card, i) => { card.dataset.value = digits[i]; card.querySelectorAll(':scope > span > span').forEach(node => { node.textContent = digits[i]; }); });
      });
      const ended = $('[data-launch-ended]'); if (ended) ended.hidden = remaining > 0;
      const dateLabel = $('[data-launch-date-label]');
      if (dateLabel) { try { dateLabel.textContent = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: clock.dataset.launchTimezone }).format(launch); } catch { dateLabel.textContent = clock.dataset.launchDate; } }
      clearTimeout(clockTimer); if (!document.hidden) clockTimer = setTimeout(updateClock, 1000);
    }
    on(document, 'visibilitychange', updateClock);
    const video = $('[data-background-video]'); const toggle = $('[data-video-toggle]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)'); const mobile = matchMedia('(max-width: 760px)');
    function videoState(playing) {
      if ($('#top')) $('#top').dataset.videoState = playing ? 'playing' : 'paused';
      toggle?.setAttribute('aria-pressed', String(!playing));
      const label = toggle?.querySelector('span'); if (label) label.textContent = playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel;
      const icon = toggle?.querySelector('use'); if (icon) icon.setAttribute('href', playing ? '#punki-icon-pause' : '#punki-icon-play');
    }
    async function startVideo(userInitiated = false) {
      if (!video || (reduced.matches && !userInitiated)) return;
      const source = mobile.matches ? (video.dataset.mobileSrc || video.dataset.desktopSrc) : (video.dataset.desktopSrc || video.dataset.mobileSrc);
      if (!source) { if (toggle) toggle.hidden = true; return; }
      if (video.getAttribute('src') !== source) { video.src = source; video.load(); }
      video.muted = true; video.defaultMuted = true; video.playsInline = true;
      try { await video.play(); } catch { videoState(false); }
    }
    on(video, 'playing', () => videoState(true)); on(video, 'pause', () => videoState(false));
    on(toggle, 'click', () => { if (video?.paused) startVideo(true); else { video?.pause(); videoState(false); } });
    on(mobile, 'change', () => startVideo());
    on(document, 'visibilitychange', () => { if (document.hidden) video?.pause(); else startVideo(); });
    selectFinish(state.finish); updateClock();
    const autoplayTimer = setTimeout(() => startVideo(), 0);
    const success = $('.launch-feedback:not([hidden])'); if (success) { success.scrollIntoView({ block: 'center' }); success.focus({ preventScroll: true }); }
    cleanup = () => { controller.abort(); clearTimeout(clockTimer); clearTimeout(autoplayTimer); video?.pause(); };
  }
  window.PunkiTheme = Object.freeze({ parseLaunchDate, initialize });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', initialize);
})();
